import { Env } from '../helpers/enums';

const apiAddress = document.querySelector('[property="api_address"]').content;

class AppConfig {

	static ENV = Env.PROD;
	static srAddress = '';
	static booongoSRAddress = '';
	static jackpotSRAddress = '';
	static booongoAddress = '';
	static memberChangeSRAddress = '';
	static virtualFeedSR = '';
	static spinAndWinFeedSR = '';
	static luckyNumbersFeedSR = '';
	static staticFeedSR = '';
	static liveFeedSR = '';
	static icons = '';
	static symbols = '';
	static teamsIconPath = '';
	static countryFlagImagesPath ='';
	static ShowSignInAndRegistersBtn = true;
	static bannerSR=''
	static headerTabs=[]

	static VirtualAddress =
		{
			VFL: "",
			VHC: "",
			VFLM: "",
			VBL: "",
			VTO: "",
			VDR: "",
			EPL: "",
		};

	static StatisticsAddress = {
		Domain: "",
		Static: "",
		Virtual: "",
		Menu: "",
		VFL: "",
		VHC: "",
		VFLM: "",
		VBL: "",
		VTO: "",
		VDR: "",
		EPL: "",
	};

	static api =
		{
			contactUs: apiAddress + `/api/ContactUs`,
			auth: apiAddress + `/api/Auth`,
			register: apiAddress + `/api/Register`,
			members: apiAddress + `/api/Members`,
			pages: apiAddress + `/api/Pages`,
			general: apiAddress + `/api/General`,
			slots: apiAddress + `/api/Slots`,
			pageMessages: apiAddress + `/api/PageMessages`
			
		}

	static version = `2.0.157.${(AppConfig.ENV === Env.DEV || AppConfig.ENV === Env.LOCAL || AppConfig.ENV === Env.DEV_HTTPS) ? "D" : "R"}`;
}


export default AppConfig;
